module.exports = __webpack_public_path__ + "img/tarj1-2.c5a96e58.svg";